import Input from "../components/input/Input";
import * as Yup from "yup";
import Button from "../components/button/Button";
import { Formik, Form } from "formik";
import Steps from "../components/steps/Steps";
import { ReactComponent as PasswordIlustration } from "../assets/images/password-ilustration.svg";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ROUTES } from "../constants/routes";
import { useResetPassword } from "../hooks/useResetPassword";
import useAuthPersistStore from "../store/authPersistStore";

const ResetPassword = () => {
  const isTablet = useMediaQuery({ query: "(min-width: 800px)" });
  const isDesktop = useMediaQuery({ query: "(min-width: 1200px)" });
  const { mutate, isLoading } = useResetPassword();
  const navigate = useNavigate();
  const location = useLocation();
  const [userId, setUserId] = useState("");
  const [token, setToken] = useState("");
  const { setLogin } = useAuthPersistStore();
  const validationSchema = Yup.object({
    password: Yup.string()
      .required("Obavezno polje")
      .min(8, "Mora imati najmanje 8 karaktera")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
        "Najmanje 8 karaktera (Obavezno veliko i malo slovo, broj)"
      ),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref("password"), undefined],
        "Potvrda lozinke mora se poklapati sa lozinkom"
      )
      .required("Obavezno polje"),
  });

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location?.search);

      const userId = searchParams.get("userId");
      const token = searchParams.get("token");

      if (userId && token) {
        setUserId(userId);
        setToken(token);
      }
    }
  }, [location]);

  return (
    <div className="create-profile">
      <Steps steps={4} activeStep={3} />
      <div className="create-profile_page">
        <div>
          <div className="create-profile_header">
            <div className="create-profile_header-content">
              <h1>Kreiraj novu lozinku</h1>
            </div>
            {isTablet && !isDesktop && <PasswordIlustration className="hover-float" />}
          </div>
          <Formik
            onSubmit={(values, actions) => {
              const { password } = values;

              mutate(
                {
                  token: token,
                  userId: userId,
                  newPassword: password,
                },
                {
                  onSuccess: (data) => {
                    // @ts-ignore
                    const { accessToken, user } = data;
                    setLogin(accessToken, user);

                    if (!user?.userProfile.fullName) {
                      navigate(ROUTES.createProfile);
                      return;
                    }

                    navigate(ROUTES.resetPasswordSuccess);
                  },
                  onError: (response) => {
                    actions.setFieldError(
                      "password",
                      // @ts-ignore
                      response?.response?.data?.message ||
                        "Something went wrong"
                    );
                  },
                }
              );
            }}
            validationSchema={validationSchema}
            initialValues={{
              password: "",
              confirmPassword: "",
            }}
            enableReinitialize
          >
            <Form className="create-profile_form">
              <Input
                name="password"
                label="Unesite novu lozinku"
                type="password"
                placeholder="Unesite novu lozinku"
                autoFocus
              />
              <Input
                name="confirmPassword"
                label="Ponovite novu lozinku"
                type="password"
                placeholder="Ponovite novu lozinku"
                autoFocus
              />
              <Button
                variant="primary"
                label="Kreiraj lozinku"
                type="submit"
                hasLoader={true}
                isLoading={isLoading}
                disabled={isLoading}
              />
            </Form>
          </Formik>
        </div>
        {isDesktop && <PasswordIlustration className="hover-float" />}
      </div>
    </div>
  );
};

export default ResetPassword;
